import React, { useEffect, useRef, useState } from "react";
import logo from "../images/logo.png";
import img1 from "../images/das-1.png";
import img2 from "../images/das-2.png";
import img3 from "../images/das-3.png";
import img4 from "../images/das-4.png";
import img5 from "../images/das-5.png";
import img6 from "../images/das-6.png";
import img7 from "../images/das-7.png";
import img8 from "../images/das-8.png";
import profileimg from "../images/profile-main.jpg";
import { Link, useNavigate } from "react-router-dom";
import img9 from "../images/das-9.png";
import { useDispatch, useSelector } from "react-redux";
import { customer_subscription, profileget } from "../redux/authslice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag, faLock } from "@fortawesome/free-solid-svg-icons";

const SidebarLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { customersubscrip } = useSelector((state) => state.counter);
  const { profiledata } = useSelector((state) => state.counter);
  const [sidebar, setSideBar] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const path = window.location.pathname;

  const logout = () => {
    localStorage.clear();
    handleLinkClick();
    navigate("/");
  };

  useEffect(() => {
    dispatch(profileget(dispatch));
    dispatch(customer_subscription(dispatch));
  }, []);

  const home = () => {
    if (!token) {
      navigate("/");
    } else {
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSideBar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      setSideBar(false);
    }
  };

  return (
    <>
      <div className={sidebar ? "side-bar-on" : "side-bar"} ref={sidebarRef}>
        <div className="logo-div-12" onClick={home}>
          <img
            src={logo}
            className="logo-img-12"
            alt=""
            style={{ cursor: "pointer" }}
          />
        </div>
        <ul className="sidebar-ul-12">
          <li className={path === "/dashboard" ? "active-class" : ""}>
            <Link to="/dashboard" onClick={handleLinkClick}>
              <div className="width-only-side">
                <img src={img1} alt="" />
              </div>
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to={
                customersubscrip?.length == 0
                  ? "/paymentsubscription"
                  : "/quizgenerator"
              }
              className={path === "/quizgenerator" ? "active-class" : ""}
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img2} alt="" />
              </div>
              Generate quiz
            </Link>
          </li>
          <li>
            <Link
              to={
                customersubscrip?.length == 0
                  ? "/paymentsubscription"
                  : "/history"
              }
              className={path === "/history" ? "active-class" : ""}
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img3} alt="" />
              </div>
              My quizzes
            </Link>
          </li>
          <li>
            <a
              href=" https://edubridge.org.uk/about-us"
              target="_blank"
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img4} alt="" />
              </div>
              About us
            </a>
          </li>
          <li>
            <a
              href="https://edubridge.org.uk/contact-us"
              target="_blank"
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img5} alt="" />
              </div>
              Contact us
            </a>
          </li>
          <li>
            <a
              href="https://edubridge.org.uk/faqs"
              target="_blank"
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img6} alt="" />
              </div>
              FAQ’s
            </a>
          </li>
          <li>
            <a
              href="https://edubridge.org.uk/how-it-works"
              target="_blank"
              onClick={handleLinkClick}
            >
              <div className="width-only-side">
                <img src={img7} alt="" />
              </div>
              1:1 tutoring
            </a>
          </li>
          <li className={path === "/settings" ? "active-class" : ""}>
            <Link to="/settings" onClick={handleLinkClick}>
              <div className="width-only-side">
                <img src={img8} alt="" />
              </div>
              Settings
            </Link>
          </li>
          <li>
            <Link to="/terms" onClick={handleLinkClick}>
              <div className="width-only-side">
                <FontAwesomeIcon
                  className="fa-light fa-flag"
                  icon={faFlag}
                  style={{ color: "#dededea3" }}
                />
              </div>
              Terms of service
            </Link>
          </li>
          <li>
            <Link to="/privacy" onClick={handleLinkClick}>
              <div className="width-only-side">
                <FontAwesomeIcon
                  icon={faLock}
                  className="fa-regular fa-flag"
                  style={{ color: "#dededea3" }}
                />
              </div>
              Privacy policy
            </Link>
          </li>
        </ul>
        <div className="pro-mob">
          {/* {!token?
                        (<Link to="/profile" className="profile-link">
                            <div className="width-only-side1">
                                <img src={profile} alt="" />
                                James Smith
                            </div>
                            <img src={img9} alt="..." />
                        </Link>) :
                        (<Link to="/signin" className="profile-log-out">
                            <p> Log in</p>
                        </Link>)}; */}
          {!token ? (
            <ul className="sidebar-ul-12">
              <li className={path === "/profile" ? "active-class" : ""}>
                <button
                  className="btn btn-primary w-100"
                  onClick={() => navigate("/signin")}
                >
                  {" "}
                  Log in
                </button>
              </li>
            </ul>
          ) : (
            <>
              <ul className="sidebar-ul-12">
                <li>
                  <Link to="/profile" onClick={handleLinkClick}>
                    <div className="width-only-side1">
                      {profiledata?.user_image ? (
                        <p>
                          <img
                            // src={`https://quizapi.trickywebsolutions.com${profiledata.user_image}`}
                            src={profiledata.user_image}
                            alt="..."
                          />
                          {profiledata?.first_name}
                        </p>
                      ) : (
                        <p>
                          <img src={profileimg} alt="..." />
                          {profiledata?.first_name}
                        </p>
                      )}
                    </div>
                    <img src={img9} alt="..." />
                  </Link>
                </li>
              </ul>

              {/* <Link to="/signin" className="profile-log-out2" >
                                <span style={{justifyItems:'center', display:'flex'}}> Log out</span>
                            </Link> */}
              <button className="logout-btn" onClick={logout}>
                Log Out
              </button>
            </>
          )}

          {/* <Link to="/profile"  className={path === "/profile" ? "active-class profile-log-out1" : "profile-log-out"} >
                        <p>
                            <img src={profile} alt="" />
                            James Smith
                        </p>    
                        <img src={img9} alt="..." />
                    </Link> */}
        </div>
      </div>
      <div
        className="d-flex justify-content-end p-3 d-lg-none"
        style={{ backgroundColor: "#576FA8" }}
      >
        <div>
          <img
            src={logo}
            className="w-50"
            alt=""
            style={{ cursor: "pointer" }}
          />
        </div>
        <div>
          <i
            className="fa-solid fa-bars text-white"
            onClick={() => setSideBar(!sidebar)}
          ></i>
        </div>
      </div>

      {children}
    </>
  );
};

export default SidebarLayout;
